import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
  } from '@angular/core';
  import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
  import { LookupService } from '../../../../services/lookup.service';
  import { TimesheetService } from '../../../../services/timesheet.service';
  import { CommonModule } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { TableModule } from 'primeng/table';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { UserService } from '../../../../services/user.service';
  
  @Component({
    selector: 'ppl-timesheet-staff-authdata',
    standalone: true,
    imports: [
        CommonModule,
        NgZorroModule,
        ReactiveFormsModule,
        NzDatePickerModule,
        FormsModule,
        TableModule,
        NzTimePickerModule,
        NzToolTipModule
    ],
    templateUrl: './timesheet-staff-authdata.component.html',
    styleUrl: './timesheet-staff-authdata.component.css',
  })
  export class TimesheetStaffAuthDataComponent implements OnInit {

    programName!: string;
    @Input() authData: any;

    @Output() showAuthDetails = new EventEmitter<any>();

    constructor(
        private fb: FormBuilder,
        private lookupService: LookupService,
        private timesheetService: TimesheetService,
        private userService: UserService
      ) {
      }

    ngOnInit(): void {
        const selectedProgram = this.userService.getSelectedProgram();
        this.programName = selectedProgram?.program_code ?? '';
    }

    showDetails(rowData: any) {
      this.showAuthDetails.emit(rowData);
    }
  }